"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilIconWarning = void 0;
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var utils_1 = require("../utils");
var AlertWarning = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.1688 3.50002L1.86876 18.5C1.61876 19 1.76876 19.6 2.26876 19.85C2.41876 19.95 2.56876 20 2.76876 20H20.2688C20.8188 20 21.2688 19.55 21.2688 19C21.2688 18.8 21.2188 18.65 21.1188 18.5L11.9188 3.50002C11.6188 3.00002 11.0188 2.85002 10.5188 3.15002C10.3688 3.20002 10.2688 3.35002 10.1688 3.50002ZM11.0188 8C11.5688 8 12.0188 8.45 12.0188 9V14C12.0188 14.55 11.5688 15 11.0188 15C10.4688 15 10.0188 14.55 10.0188 14V9C10.0188 8.45 10.4688 8 11.0188 8ZM12.0188 17C12.0188 16.45 11.5688 16 11.0188 16C10.4688 16 10.0188 16.45 10.0188 17C10.0188 17.55 10.4688 18 11.0188 18C11.5688 18 12.0188 17.55 12.0188 17Z" }))); };
exports.UtilIconWarning = (0, utils_1.withDeprecationWarning)(AlertWarning, 'UtilIconWarning');
exports.default = AlertWarning;
